// app/localization/index.js
import { createI18n } from 'vue-i18n';
import { i18nManager } from '@ozdao/martyrs/modules/core/client';

import translations from './translations.js';
import overrides from './overrides.js';
import extensions from './extensions.js';

const supportedLocales = {
  en: "🌎 EN",
};

// Настройка переводов приложения
export function getLocales() {
  i18nManager.setSupportedLocales(supportedLocales);
  i18nManager.setDefaultLocale('en');

  // Регистрируем локальные переводы
  if (translations) {
    Object.entries(translations).forEach(([module, locales]) => {
      i18nManager.register(module, locales);
    });
  }

  // Применяем расширения если есть
  if (extensions) {
    Object.entries(extensions).forEach(([module, locales]) => {
      i18nManager.extend(module, locales);
    });
  }

  // Применяем переопределения если есть
  if (overrides) {
    Object.entries(overrides).forEach(([module, locales]) => {
      i18nManager.override(module, locales);
    });
  }

  // Получаем финальные переводы
  const messages = i18nManager.getAllMessages();

  // Создаем экземпляр i18n
  const i18n = createI18n({
    legacy: false,
    locale: 'en',
    fallbackLocale: 'en',
    messages,
    globalInjection: true,
    availableLocales: Object.keys(supportedLocales),
    pluralRules: i18nManager.pluralRules,
  });

  // ОБЯЗАТЕЛЬНО! Без этого модули не смогут добавлять переводы динамически.
  // Теперь это делает ядро: инстанс кладёт в контекст запроса createApp
  // (core.app.js), потому что контекст — на запрос, а i18nManager — на процесс.
  // Регистрировать его здесь больше нечем: setI18nInstance в martyrs удалён.

  return i18n;
}
